import React from "react";

import { Link } from "gatsby";

import Tracker from "services/gaTracker";
import { ICardContent } from "types";

import ThemeBuyButton from "components/ThemeBuyButton";

import ImageSkeletonComponent from "./ImageSkeletonComponent";

import { getIconWithoutBackgroudData as getIconData } from "utils/iconProvider";
import { getLinkViewData, getPurchaseTrackerData } from "utils/trackerHelper";

const CardRibbon = ({
  ribbonContent,
}: {
  ribbonContent: string[] | undefined;
}) => {
  if (!ribbonContent) return null;

  return (
    <>
      <div className="absolute -top-[3.25rem] right-[1.875rem] flex h-[11.375rem] w-[2.5rem] -rotate-45 justify-center bg-primary-100">
        <div className="flex flex-col justify-center gap-4">
          {ribbonContent.map((ribbonItem, index) => (
            <React.Fragment key={index}>
              <img
                src={getIconData(ribbonItem).icon}
                alt={getIconData(ribbonItem).alt}
                className="rotate-45 w-fit"
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

const Card: React.FC<ICardContent> = ({
  technologies,
  featuredImage,
  name,
  author,
  type,
  price,
  comparePrice,
  url,
  previewUrl,
  purchaseInfo,
  title,
  gumroadId,
  mainTechnology,
  downloadDetails,
  ribbonContent,
}) => {
  const handlePreviewButton = (event: any) => {
    Tracker.trackPreview(previewUrl);
    event.stopPropagation();
  };

  const handleBuyButton = (event: any) => {
    const user = localStorage.getItem("user");
    let primaryEmail = "";
    const secondaryEmail = localStorage.getItem("downloadModalEmail");

    if (user) {
      const email = JSON.parse(user as string).email;

      primaryEmail = email;
    }

    const purchaseData = getPurchaseTrackerData(
      price,
      gumroadId,
      title,
      mainTechnology,
      primaryEmail,
      secondaryEmail
    );

    Tracker.trackBuy(purchaseData);
    event.stopPropagation();
  };

  function handleCardClick() {
    const pageDataForTracker = getLinkViewData(price, gumroadId, title, url);

    Tracker.trackDetailPageView(pageDataForTracker);
  }

  return (
    <div className="relative overflow-hidden transition-shadow bg-white border border-gray-200 rounded swiper-card hover:shadow-primary-200 hover:shadow-md">
      <Link to={url.includes("http") ? url : `/${url}`} onClick={handleCardClick} target={url.includes("http") ? "_blank" : ''}>
        <CardRibbon ribbonContent={ribbonContent} />
        <div className="h-[12.5rem] sm:h-[19.5rem]">
          <ImageSkeletonComponent
            src={featuredImage}
            alt={name}
            imageClassname="object-cover w-full h-full rounded-t"
          />
        </div>
        <div className="px-4 py-6">

          {technologies && <p className="mb-2 text-sm text-neutral-500">Technologies:</p>}
          <div className="flex flex-wrap gap-2 mb-4">
            {(technologies || []).map((technology: any, index) => (
              <Link
                key={index}
                to={
                  "/technology/" +
                  encodeURIComponent(technology.title.toLowerCase())
                }
              >
                <div
                  className={`rounded px-2 py-1 ${technology.class}`}
                  key={technology.title}
                >
                  <p className="text-sm text-black">{technology.title}</p>
                </div>
              </Link>
            ))}
          </div>

          <p className="mb-1 text-lg font-semibold text-gray-700">{name}</p>

          {author && <p className="mb-1 text-sm text-neutral-500">
            by <span className="font-medium">{author}</span>
          </p>}

          <p className="mb-2 text-neutral-500">{type}</p>

          <div className="flex items-center justify-between">
            <div>
              <span className="text-xl font-semibold text-primary-500">{price} </span><span className={price == comparePrice ? 'hidden' : "text-gray-400 line-through"}>{comparePrice}</span>
            </div>
            <div className="flex gap-2">
              {/* <Link to="/cart">
              <button className="btn-primary-outline">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="stroke-blue-500"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_308_10579)">
                    <path
                      d="M6 21C7.10457 21 8 20.1046 8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21Z"
                      stroke=""
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17C15.8954 17 15 17.8954 15 19C15 20.1046 15.8954 21 17 21Z"
                      stroke=""
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 17H6V3H4"
                      stroke=""
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6 5L20 6L19 13H6"
                      stroke=""
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_308_10579">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </Link> */}
              {previewUrl &&
                <Link
                  to={previewUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <button
                    className="btn-primary-outline"
                    onClick={handlePreviewButton}
                  >
                    Preview
                  </button>
                </Link>}
              <ThemeBuyButton
                purchaseInfo={purchaseInfo}
                downloadDetails={downloadDetails}
                handleBuyButtonClick={handleBuyButton}
                classname="btn-primary"
              />
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
